import { render, staticRenderFns } from "./HospitalizedLine.vue?vue&type=template&id=21e09128&scoped=true&"
import script from "./HospitalizedLine.vue?vue&type=script&lang=tsx&"
export * from "./HospitalizedLine.vue?vue&type=script&lang=tsx&"
import style0 from "./HospitalizedLine.vue?vue&type=style&index=0&id=21e09128&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e09128",
  null
  
)

export default component.exports